import React, { useEffect, useState } from "react";

import { ToastContainer } from "react-toastify";
import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineUserAdd, AiOutlineDelete } from "react-icons/ai";
import { FiFilter } from "react-icons/fi";
import { FcRefresh } from "react-icons/fc";
import { FiEdit2 } from "react-icons/fi";
import { BsArrowLeft } from "react-icons/bs";
import DashLayout from "../../layouts/DashLayout";
import Table from "../../components/Table";
import Overlay from "../../components/Overlay";
import Action from "../../components/Action";
import { beneficiaryStatus } from "../../utils/DataSource";
import { style, color } from "../../styles/Style";
import { useDispatch } from "react-redux";
import ContentLoader from "react-content-loader";
import {
  getResidentials,
  addnewResidential,
  updateResidential,
  deleteResidential,
} from "../../store/actions/ResidentialsActions";
import {
  addBenHome,
  deleteBenHome,
  getBenHomes,
  updateBenHome,
} from "../../store/actions/BeneficiriesHome";
import { getBeneficiries } from "../../store/actions/BenActions";
import { useSelector } from "react-redux";
import changeMonthToText from "../../utils/ChangeMonthToText";
import DownloadBtn from "../../components/DownloadBtn";
import { currentDate } from "../../utils/currentDate";

function Residence() {
  // dispatch declarition
  const dispatch = useDispatch();
  const residences = useSelector((state) => state.residentials);
  const benHomes = useSelector((state) => state.benHomes);
  const beneficiaries = useSelector((state) => state.beneficiries);
  const loaders = useSelector((state) => state.loadersState);

  // residence variable decl.
  const [residence, setResidence] = useState({
    id: "",
    cell: "",
    commonName: "",
    district: "",
    province: "",
    sector: "",
    village: "",
  });
  const [benHome, setBenHome] = useState({
    id: "",
    beneficiaryId: "",
    endDate: "",
    residentialPlace: "",
    startDate: "",
    status: "",
  });
  function clearOverlayInput() {
    dispatch({
      type: "SET_BEN_RESIDENCE_MESSAGE",
      message: "",
    });
    dispatch({
      type: "SET_RESIDENCE_MESSAGE",
      message: "",
    });

    setBenHome({
      id: "",
      beneficiaryId: "",
      endDate: "",
      residentialPlace: "",
      startDate: "",
      status: "",
    });

    setResidence({
      id: "",
      cell: "",
      commonName: "",
      district: "",
      province: "",
      sector: "",
      village: "",
    });
  }
  // opening tabs state
  const [openTab, setOpenTab] = useState(1);
  // overlays
  const [addBenOverlay, setAddBeneOverlay] = useState(0);
  function benOverlayController() {
    setAddBeneOverlay(!addBenOverlay);
    clearOverlayInput();
  }
  // filter overlay controller
  const [filterBenOverlay, setFilterBeneOverlay] = useState(0);
  function filterOverlayController() {
    setFilterBeneOverlay(!filterBenOverlay);
  }
  // editing overlay controller
  const [editBenOverlay, setEditBeneOverlay] = useState(0);
  function editOverlayController(passedHome) {
    setEditBeneOverlay(!editBenOverlay);
    setBenHome({
      id: passedHome.id,
      beneficiaryId: passedHome.beneficiaryId,
      endDate: passedHome.end,
      residentialPlace: passedHome.residenceId,
      startDate: passedHome.start,
      status: passedHome.stati,
    });
  }
  // adding residence controller
  const [addresidence, setAddresidence] = useState(0);
  function addresidenceController() {
    setAddresidence(!addresidence);
  }
  // edit residence controller
  const [editresidence, setEditresidence] = useState(0);
  function editresidenceController(passedResidential) {
    setEditresidence(!editresidence);
    setResidence({
      id: passedResidential.id,
      cell: passedResidential.cell,
      commonName: passedResidential.commonName,
      district: passedResidential.district,
      province: passedResidential.province,
      sector: passedResidential.sector,
      village: passedResidential.village,
    });
  }
  // dropdowns
  // residence dropdowns
  const [residenceDropdown, setresidenceDropDown] = useState(0);
  // for Residence table
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "Beneficiary",
        accessor: "beneficiary",
      },
      {
        Header: "Residential",
        accessor: "residence",
      },
      {
        Header: "StartDate",
        accessor: "startDate",
      },
      {
        Header: "EndDate",
        accessor: "endDate",
      },

      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  // handle residence submit
  const handleResidenceSubmit = (e) => {
    e.preventDefault();
    if (residence.id) {
      const id = residence.id;
      const updatedResidential = {
        cell: residence.cell,
        commonName: residence.commonName,
        district: residence.district,
        province: residence.province,
        sector: residence.sector,
        village: residence.village,
      };
      dispatch(
        updateResidential(updatedResidential, id, closeResidenceAfterUpdating)
      );
    } else {
      dispatch(addnewResidential(residence, closeResidenceFormAfterAdding));
    }
  };
  // reload homes
  useEffect(() => {
    dispatch(getResidentials());    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reload beneficiries residentials
  useEffect(() => {
    dispatch(getBenHomes());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // reload beneficiries
  useEffect(() => {
    dispatch(getBeneficiries());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const provinces = [
    {
      id: 0,
      label: "Eastern",
      value: "Eastern",
      districts: [
        {
          label: "Rwamagana",
          value: "Rwamagana",
        },
        {
          label: "Bugesera",
          value: "Bugesera",
        },
        {
          label: "Gatsibo",
          value: "Gatsibo",
        },
        {
          label: "Kayonza",
          value: "Kayonza",
        },
        {
          label: "Kirehe",
          value: "Kirehe",
        },
        {
          label: "Ngoma",
          value: "Ngoma",
        },
        {
          label: "Nyagatare",
          value: "Nyagatare",
        },
      ],
    },
    {
      id: 1,
      label: "Northern",
      value: "Northern",
      districts: [
        {
          label: "Burera",
          value: "Burera",
        },
        {
          label: "Gakenke",
          value: "Gakenke",
        },
        {
          label: "Gicumbi",
          value: "Gicumbi",
        },
        {
          label: "Musanze",
          value: "Musanze",
        },
        {
          label: "Rulindo",
          value: "Rulindo",
        },
      ],
    },
    {
      id: 2,
      label: "Southern",
      value: "Southern",
      districts: [
        {
          label: "Gisagara",
          value: "Gisagara",
        },
        {
          label: "Huye",
          value: "Huye",
        },
        {
          label: "Kamonyi",
          value: "Kamonyi",
        },
        {
          label: "Muhanga",
          value: "Muhanga",
        },
        {
          label: "Nyamagabe",
          value: "Nyamagabe",
        },
        {
          label: "Ruhango",
          value: "Ruhango",
        },
        {
          label: "Nyaruguru",
          value: "Nyaruguru",
        },
        {
          label: "Nyanza",
          value: "Nyanza",
        },
      ],
    },
    {
      id: 3,
      label: "Western",
      value: "Western",
      districts: [
        {
          label: "Karongi",
          value: "Karongi",
        },
        {
          label: "Ngororero",
          value: "Ngororero",
        },
        {
          label: "Nyabihu",
          value: "Nyabihu",
        },
        {
          label: "Nyamasheke",
          value: "Nyamasheke",
        },
        {
          label: "Rubavu",
          value: "Rubavu",
        },
        {
          label: "Rusizi",
          value: "Rusizi",
        },
        {
          label: "Rutsiro",
          value: "Rutsiro",
        },
      ],
    },
    {
      id: 4,
      label: "Kigali",
      value: "Kigali",
      districts: [
        {
          label: "Gasabo",
          value: "Gasabo",
        },
        {
          label: "Kicukiro",
          value: "Kicukiro",
        },
        {
          label: "Nyarugenge",
          value: "Nyarugenge",
        },
      ],
    },
    {
      value: "",
      districts: [],
    },
  ];

  const selectedDistricts = provinces.find(
    (province) => province.value === residence.province
  ).districts;

  // handle delete
  const handleDelete = (id) => {
    dispatch(deleteResidential(id));
  };
  // handle delete
  const handleHomeDeletion = (id) => {
    dispatch(deleteBenHome(id));
  };

  // handleBenresidenceSubmit
  const handleBenHomeSubmit = (e) => {
    e.preventDefault();
    if (benHome.id) {
      const id = benHome.id;
      const updatedBenHome = {
        beneficiaryId: benHome.beneficiaryId,
        endDate: benHome.endDate,
        locationId: { idValue: benHome.residentialPlace },
        startDate: benHome.startDate,
        status: benHome.status,
      };
      dispatch(
        updateBenHome(updatedBenHome, id, closeBenResidenceAfterUpdating)
      );
    } else {
      const newBenHome = {
        ...benHome,
        locationId: { idValue: benHome.residentialPlace },
      };
      dispatch(addBenHome(newBenHome, closeBenResidenceFormAfterAdding));
    }
  };

  // beneficiries select option
  const beneficiriesOption = [];
  for (let i = 0; i < beneficiaries.length; i++) {
    const beneficiary = {
      value: beneficiaries[i].id,
      label: beneficiaries[i].beneficiaryCode,
      name: beneficiaries[i].firstName + " " + beneficiaries[i].lastName,
    };

    beneficiriesOption.push(beneficiary);
  }

  // residence select option
  const residencesOption = [];
  for (let i = 0; i < residences.length; i++) {
    const residence = {
      value: residences[i].id,
      label: residences[i].commonName,
    };

    residencesOption.push(residence);
  }
  // residential status

  const selectedBeneficiary = beneficiriesOption.filter(
    (beneficiary) => beneficiary.value === benHome.beneficiaryId
  );

  // transform residence data
  let [loadedResidence, setLoadedResidence] = useState([]);

  useEffect(() => {
    setLoadedResidence([]);
    for (let i = 0; i < benHomes.length; i++) {
      const home = {
        count: i + 1,
        id: benHomes[i].id,
        beneficiary: ` ${benHomes[i].beneficiary.firstName}  
          ${benHomes[i].beneficiary.lastName}`,
        beneficiaryId: benHomes[i].beneficiary.id,
        residenceId: benHomes[i].location.id,
        residence: benHomes[i].location.commonName,
        startDate: changeMonthToText(benHomes[i].startDate),
        endDate: changeMonthToText(benHomes[i].endDate),
        start: benHomes[i].startDate,
        end: benHomes[i].endDate,
        stati: benHomes[i].status,
        status: (
          <div className="py-1 px-2 rounded text-indigo-500 bg-indigo-50 font-normal fit-content">
            {benHomes[i].status}
          </div>
        ),
        action: (
          <Action
            editAction={() => editOverlayController(home)}
            deleteAction={() => {
              handleHomeDeletion(benHomes[i].id);
            }}
          />
        ),
      };
      setLoadedResidence((loadedResidence) => [...loadedResidence, home]);

      if (
        loaders.benResidence.deletingAction &&
        loaders.benResidence.deletingAction.deleting
      ) {
        const currentBenResidences = loadedResidence;
        const newData = currentBenResidences.map((benResidence) =>
          benResidence.id === loaders.benResidence.deletingAction.id
            ? {
              ...benResidence,
              action: (
                <div className="spinner red-spinner m-auto">
                  <div className="bounce1"></div>
                  <div className="bounce2"></div>
                  <div className="bounce3"></div>
                </div>
              ),
            }
            : benResidence
        );
        setLoadedResidence(newData);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benHomes, loaders.benResidence.deletingAction]);

  let [loadingBenResidences, setLoadingBenResidences] = useState([]);

  useEffect(() => {
    setLoadingBenResidences([]);
    for (let i = 0; i < 5; i++) {
      const benResidence = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiary: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        residence: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        startDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        endDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        status: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
      };
      setLoadingBenResidences((loadingBenResidences) => [
        ...loadingBenResidences,
        benResidence,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaders.benResidence.fetchingLoaders]);


  // closing residence after cu
  function closeResidenceFormAfterAdding() {
    addresidenceController();
    setResidence({
      id: "",
      cell: "",
      commonName: "",
      district: "",
      province: "",
      sector: "",
      village: "",
    });
  }

  function closeResidenceAfterUpdating() {
    editresidenceController({
      id: "",
      cell: "",
      commonName: "",
      district: "",
      province: "",
      sector: "",
      village: "",
    });
  }
  // closing ben home after cu
  function closeBenResidenceFormAfterAdding() {
    benOverlayController();
    setBenHome({
      id: "",
      beneficiaryId: "",
      endDate: "",
      residentialPlace: "",
      startDate: "",
      status: "",
    });
  }

  function closeBenResidenceAfterUpdating() {
    editOverlayController({
      id: "",
      beneficiaryId: "",
      endDate: "",
      residentialPlace: "",
      startDate: "",
      status: "",
    });
  }

  function clearErrors() {
    dispatch({
      type: "SET_BEN_RESIDENCE_MESSAGE",
      message: "",
    });
    dispatch({
      type: "SET_RESIDENCE_MESSAGE",
      message: "",
    });
  }
  return (
    <DashLayout>
      <div className="bg-white mx-10">
        <div className="text-xs">
          <ToastContainer />
        </div>
        <div className="flex flex-col md:flex-row p-10 pt-5 pl-10 pb-0">
          <h2 className="font-semibold">Beneficiary residences</h2>
          <div className="md:m-auto mt-2 md:mr-0">
            <button
              className="p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400 title-tip"
              message="Register"
              onClick={() => {
                benOverlayController();
              }}
            >
              <AiOutlineUserAdd />
            </button>

            <button
              className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100 title-tip"
              message="Filter"
              onClick={() => {
                filterOverlayController();
              }}
            >
              <FiFilter />
            </button>

            <button
              className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100 title-tip"
              message="Refresh"
            >
              <FcRefresh />
            </button>

            <DownloadBtn filename={`residences-${changeMonthToText(currentDate())}`} table="table-to-xls" />
          </div>
        </div>
        <div className="pb-5 px-0 pr-10 flex flex-wrap  w-full pt-2">
          {/* Residence table */}
          <div className="w-full">
            {(!loaders.benResidence.fetchingLoaders && benHomes.length < 1) |
              loaders.benResidence.fetchFailedMessage ? (
              <div
                className={
                  !loaders.benResidence.fetchFailedMessage
                    ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                    : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                }
              >
                <p>
                  {!loaders.benResidence.fetchFailedMessage
                    ? "No residence record found"
                    : loaders.benResidence.fetchFailedMessage}
                </p>
              </div>
            ) : (
              <Table
                data={
                  loaders.benResidence.fetchingLoaders
                    ? loadingBenResidences
                    : loadedResidence
                }
                columns={columns}
              />
            )}
          </div>
        </div>
        {/*add beneficiary overlay  */}
        <div
          className={
            addBenOverlay || editBenOverlay ? "flex w-screen" : "hidden"
          }
        >
          <Overlay>
            <div className=" bg-white m-auto  rounded">
              <div
                className={
                  loaders.benResidence.message && openTab === 1
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.benResidence.message}</p>
              </div>

              <div
                className={
                  loaders.residence.message && openTab === 2
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.residence.message}</p>
              </div>
              <div className="p-10 pb-5">
                <div className="flex">
                  <h2 className="font-semibold  w-80">
                    {addBenOverlay
                      ? "Register beneficiary residence"
                      : "Change beneficiary residence info"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        addBenOverlay
                          ? benOverlayController()
                          : editOverlayController({
                            id: "",
                            beneficiaryId: "",
                            endDate: "",
                            residentialPlace: "",
                            startDate: "",
                            status: "",
                          });
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-wrap">
                  <div className="w-full">
                    <ul
                      className="flex mb-0 list-none flex-wrap  font-medium  flex-row w-full border-b border-gray-300"
                      role="tablist"
                    >
                      <li className="-mb-px  last:mr-0">
                        <a
                          className={
                            "text-xs   px-5 py-3 pl-0   block leading-normal" +
                            (openTab === 1
                              ? "text-indigo-500 border-b-2 border-" +
                              color +
                              "-600"
                              : "text-gray-500 bg-white")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(1);
                            clearErrors();
                          }}
                          data-toggle="tab"
                          href="#link1"
                          role="tablist"
                        >
                          <i className="fas fa-space-shuttle text-base mr-1"></i>{" "}
                          Beneficiary
                        </a>
                      </li>
                      <li className="-mb-px  last:mr-0">
                        <a
                          className={
                            "text-xs   px-5 py-3 pl-0  block leading-normal " +
                            (openTab === 2
                              ? "text-indigo-500 border-b-2 border-" +
                              color +
                              "-600"
                              : "text-gray-500 bg-white")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(2);
                            clearErrors();
                          }}
                          data-toggle="tab"
                          href="#link2"
                          role="tablist"
                        >
                          <i className="fas fa-cog text-base mr-1"></i>{" "}
                          Residence
                        </a>
                      </li>
                    </ul>
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2">
                      <div>
                        <div className="tab-content tab-space">
                          <div
                            className={
                              openTab === 1 ? "flex flex-col" : "hidden"
                            }
                            id="link1"
                          >
                            <form
                              className="flex flex-col pt-3"
                              onSubmit={handleBenHomeSubmit}
                              id="lap"
                            >
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Beneficiary Id</label>
                                <Select
                                  options={beneficiriesOption}
                                  value={beneficiriesOption.find(
                                    (obj) => obj.value === benHome.beneficiaryId
                                  )}
                                  onChange={(e) =>
                                    setBenHome({
                                      ...benHome,
                                      beneficiaryId: e.value,
                                    })
                                  }
                                />
                              </div>
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Name</label>
                                <div className={style.field.parentDiv}>
                                  <input
                                    type="text"
                                    className={style.field.input + "uppercase"}
                                    value={
                                      benHome.beneficiaryId
                                        ? selectedBeneficiary[0].name
                                        : ""
                                    }
                                    readOnly
                                  />
                                </div>
                              </div>
                              {/*  field */}
                              <div className="py-2  w-full">
                                <div className="flex w-full">
                                  <div>
                                    <label>Start date </label>

                                    <div
                                      className={
                                        style.field.parentDiv + " mr-2 w-1/2"
                                      }
                                    >
                                      <input
                                        type="date"
                                        className={style.field.input}
                                        value={benHome.startDate}
                                        onChange={(e) =>
                                          setBenHome({
                                            ...benHome,
                                            startDate: e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="ml-auto">
                                    <label>End date </label>

                                    <div
                                      className={
                                        style.field.parentDiv + " w-1/2"
                                      }
                                    >
                                      <input
                                        type="date"
                                        className={style.field.input}
                                        value={benHome.endDate}
                                        onChange={(e) =>
                                          setBenHome({
                                            ...benHome,
                                            endDate: e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Residential</label>
                                <Select
                                  options={residencesOption}
                                  value={residencesOption.find(
                                    (obj) =>
                                      obj.value === benHome.residentialPlace
                                  )}
                                  onChange={(e) =>
                                    setBenHome({
                                      ...benHome,
                                      residentialPlace: e.value,
                                    })
                                  }
                                />
                              </div>
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Comment</label>
                                <div
                                  className={
                                    style.field.parentDiv + " mr-2 w-1/2"
                                  }
                                >
                                  <textarea
                                    type="text"
                                    className={style.field.input}
                                    value={benHome.status}
                                    onChange={(e) =>
                                      setBenHome({
                                        ...benHome,
                                        status: e.target.value,
                                      })
                                    }
                                  ></textarea>
                                </div>
                              </div>
                              {/* save btn */}
                              <button
                                type="submit"
                                className={style.loginBtn}
                                disabled={loaders.benResidence.sendingLoader}
                              >
                                {!loaders.benResidence.sendingLoader ? (
                                  <p className="m-auto">
                                    {addBenOverlay ? "Save" : "Update"}
                                  </p>
                                ) : (
                                  <div className="spinner m-auto">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                  </div>
                                )}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="tab-content tab-space">
                          <div
                            className={
                              openTab === 2 ? "flex flex-col" : "hidden"
                            }
                            id="link1"
                          >
                            <div className="flex w-full  flex-col py-5">
                              <button
                                className={
                                  !addresidence & !editresidence
                                    ? "p-3 text-center bg-indigo-500 hover:bg-indigo-600 rounded text-white font-normal mb-3"
                                    : "hidden"
                                }
                                onClick={() => {
                                  addresidenceController();
                                }}
                              >
                                {"Add residence"}
                              </button>
                              <div
                                className={
                                  !addresidence & !editresidence
                                    ? "flex w-full flex-col py-5 pb-0"
                                    : "hidden"
                                }
                              >
                                {loaders.residence.fetchingLoaders ? (
                                  <div className="spinner m-auto indigo-spinner">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                  </div>
                                ) : (
                                  residences.map((residence, i) => {
                                    return loaders.residence.deletingAction &&
                                      loaders.residence.deletingAction.id ===
                                      residence.id ? (
                                      <div className="spinner m-auto red-spinner">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                      </div>
                                    ) : (
                                      <div
                                        className={
                                          "border border-gray-300 p-3 mb-3 rounded bg-gray-100 flex"
                                        }
                                        key={i}
                                        onClick={() => {
                                          setresidenceDropDown(i);
                                        }}
                                      >
                                        <div className="flex mb-2 m-auto mx-0 text-start cursor-pointer">
                                          <h2 className="font-semibold m-auto">
                                            {residence.commonName}
                                          </h2>
                                        </div>
                                        <div
                                          className={
                                            residenceDropdown === i
                                              ? "flex flex-col ml-auto"
                                              : "hidden"
                                          }
                                        >
                                          <div className="flex m-auto fit-content">
                                            <button
                                              className="flex p-1 rounded border border-gray-300 hover:border-gray-300 bg-gray-100 text-gray-500 mr-2"
                                              onClick={() => {
                                                editresidenceController(
                                                  residence
                                                );
                                              }}
                                            >
                                              <FiEdit2 />
                                            </button>
                                            <button
                                              className="flex p-1 rounded border border-red-300 hover:border-red-300 bg-red-300 text-red-500 mr-2"
                                              onClick={() => {
                                                handleDelete(residence.id);
                                              }}
                                            >
                                              <AiOutlineDelete />
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                              {/* add residence */}
                              <form
                                className={
                                  addresidence || editresidence
                                    ? "flex w-full flex-col  pb-0"
                                    : "hidden"
                                }
                                onSubmit={handleResidenceSubmit}
                              >
                                <h2 className="font-semibold">
                                  {addresidence
                                    ? "Register residential"
                                    : "Change residential info"}
                                </h2>
                                {/*  field */}
                                <div className="py-2  w-full">
                                  <label>Name </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={residence.commonName}
                                      onChange={(e) =>
                                        setResidence({
                                          ...residence,
                                          commonName: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Province </label>
                                  <Select
                                    options={provinces}
                                    value={provinces.find(
                                      (obj) => obj.value === residence.province
                                    )}
                                    onChange={(e) =>
                                      setResidence({
                                        ...residence,
                                        province: e.value,
                                      })
                                    }
                                  />
                                </div>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>District </label>
                                  <Select
                                    options={selectedDistricts}
                                    value={selectedDistricts.find(
                                      (obj) => obj.value === residence.district
                                    )}
                                    onChange={(e) =>
                                      setResidence({
                                        ...residence,
                                        district: e.value,
                                      })
                                    }
                                  />
                                </div>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Sector </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={residence.sector}
                                      onChange={(e) =>
                                        setResidence({
                                          ...residence,
                                          sector: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Cell </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={residence.cell}
                                      onChange={(e) =>
                                        setResidence({
                                          ...residence,
                                          cell: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Village </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={residence.village}
                                      onChange={(e) =>
                                        setResidence({
                                          ...residence,
                                          village: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                <button
                                  type="submit"
                                  className={style.loginBtn}
                                  disabled={loaders.residence.sendingLoader}
                                >
                                  {!loaders.residence.sendingLoader ? (
                                    <p className="m-auto">
                                      {addresidence ? "Save" : "Update"}
                                    </p>
                                  ) : (
                                    <div className="spinner m-auto">
                                      <div className="bounce1"></div>
                                      <div className="bounce2"></div>
                                      <div className="bounce3"></div>
                                    </div>
                                  )}
                                </button>
                                <p
                                  className={
                                    addresidence | editresidence
                                      ? "p-3  pb-0 pl-0 flex rounded text-indigo-500 font-normal cursor-pointer m-auto"
                                      : "hidden"
                                  }
                                  onClick={() => {
                                    addresidence
                                      ? addresidenceController()
                                      : editresidenceController({
                                        id: "",
                                        cell: "",
                                        commonName: "",
                                        district: "",
                                        province: "",
                                        sector: "",
                                        village: "",
                                      });
                                  }}
                                >
                                  <BsArrowLeft className="mr-2" /> {"Back"}
                                </p>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Overlay>
        </div>
        {/* filter Residence overlay */}
        <div className={filterBenOverlay ? "flex w-screen" : "hidden"}>
          <Overlay>
            <div className="p-10 pb-5 bg-white m-auto  rounded">
              <div className="flex">
                <h2 className="font-semibold my-2  w-80">
                  Filter Residentials
                </h2>
                <div className="m-auto mr-0">
                  <button
                    className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                    onClick={() => {
                      filterOverlayController();
                    }}
                  >
                    <IoCloseOutline className="text-white" />{" "}
                  </button>
                </div>
              </div>{" "}
              <div className="flex flex-col">
                {/*  field */}
                <div className="py-2 w-full">
                  <label>Beneficiary range </label>
                  <div className="flex w-full">
                    <Select
                      options={beneficiaryStatus}
                      className="w-1/2 mr-2"
                    />

                    <Select options={beneficiaryStatus} className="w-1/2" />
                  </div>
                </div>
                {/*  field */}
                <div className="py-2 w-full">
                  <label>StartDate range </label>
                  <div className="flex">
                    <div className={style.field.parentDiv + "w-1/2 mr-2"}>
                      <input type="date" className={style.field.input} />
                    </div>
                    <div className={style.field.parentDiv + "w-1/2"}>
                      <input type="date" className={style.field.input} />
                    </div>
                  </div>
                </div>
                {/*  field */}
                <div className="py-2 w-full">
                  <label>EndDate range </label>
                  <div className="flex">
                    <div className={style.field.parentDiv + "w-1/2 mr-2"}>
                      <input type="date" className={style.field.input} />
                    </div>
                    <div className={style.field.parentDiv + "w-1/2"}>
                      <input type="date" className={style.field.input} />
                    </div>
                  </div>
                </div>
                {/*  field */}
                <div className="py-2  w-full">
                  <label>Status </label>
                  <Select options={beneficiaryStatus} isMulti />
                </div>
                {/*  field */}
                <div className="py-2  w-full">
                  <label>Residentials </label>
                  <Select options={beneficiaryStatus} isMulti />
                </div>
                {/* save btn */}
                <button type="submit" className={style.loginBtn}>
                  <p className="m-auto">Kuyungurura</p>
                </button>
              </div>
            </div>
          </Overlay>
        </div>
      </div>

      <table className="table text-left table-to-export hidden" id="table-to-xls">
        <thead className="thead-dark">
          <tr>
            <th>Beneficiary</th>
            <th>Residential</th>
            <th>Start date</th>
            <th>End Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>

          {benHomes.map((benHome) =>
            <tr>
              <td>{benHome.beneficiary.firstName} {benHome.beneficiary.lastName}</td>
              <td>{benHome.location.commonName}</td>
              <td>{changeMonthToText(benHome.startDate)}</td>
              <td>{changeMonthToText(benHome.endDate)}</td>
              <td>{benHome.status}</td>
            </tr>
          )}
        </tbody>
      </table>
    </DashLayout>
  );
}

export default Residence;
